import { Link } from "react-router-dom";

/**
 * UI-24 — what a `/processing` address shows with developer mode off, or the moment
 * somebody switches it off while already on the page (`ProcessingPage`/`ProcessingBatchPage`
 * re-render into this rather than staying on a screen the rail no longer offers).
 *
 * The address still resolves rather than the wildcard's silent redirect home — the same rule
 * `FullModeOnly` (`DestinationPage.tsx`) follows for a link into full mode from simple: a
 * shared link or a bookmark must not break for the mode somebody happens to be in.
 */
export function DeveloperModeOnly({ label, summary }: { label: string; summary: string }) {
  return (
    <div className="flex max-w-[860px] flex-col gap-[var(--space-3)] px-[var(--space-8)] py-[var(--space-8)]">
      <h1 className="text-[length:var(--text-3xl)] font-extrabold tracking-[var(--tracking-snug)] text-[var(--text-primary)]">
        {label}
      </h1>
      <p className="text-[length:var(--text-md)] text-[var(--text-secondary)]">{summary}</p>
      <p className="max-w-[56ch] text-[length:var(--text-sm)] text-[var(--text-secondary)] [text-wrap:pretty]">
        This is a developer view of how insights become beliefs — what a synthesis batch read,
        what the model said, and what became a belief. Nothing here is needed to read your
        world view or answer a question.
      </p>
      <Link
        to="/settings/advanced"
        className="mt-1 inline-flex w-fit items-center rounded-[var(--radius-md)] border border-[var(--border-default)] px-3 py-1.5 text-[length:var(--text-sm)] font-semibold text-[var(--text-primary)] transition hover:bg-[var(--surface-2)]"
      >
        Turn on developer mode
      </Link>
    </div>
  );
}
